const PageProductGroups = () => import('./PageProductGroups');
const PageProductGroupManage = () => import('./pages/product-group-manage/PageProductGroupManage');

export default {
  path: 'product-groups',
  children: [
    {
      path: '',
      name: 'productGroups',
      component: PageProductGroups,
      meta: {
        title: 'Grupos de produtos',
      },
    },
    {
      path: 'manage/:id?',
      params: {
        id: null,
      },
      name: 'product-group-manage',
      component: PageProductGroupManage,
      meta: {
        title: 'Gerenciar grupo de produtos',
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-quote/features/product-groups/routes.js